import { render } from "./Contact.vue?vue&type=template&id=4956d433&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=4956d433&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4956d433"

export default script